import { callService } from "../../services/services";
import { prmData, setPrmData } from "../../utils/enums";
import { updateAlert } from "../alert/actions";
import { updateCustomerInfo } from "../customerInformation/actions";
import { addProcessContext, updateGlobalState } from "./actions";

export const getPrmData = (body) => {
  return async (dispatch) => {
    return await callService("getPrmData", body, dispatch, body.externalId)
      .then((response) => {
        const data = response.data;
        if (data.resultCode === "0") {
          setPrmData(data.prmTableOut);
          //dispatch(updateGlobalState({errorCodes:data.prmTableOut}));
          return { result: "0", nextStatus: false };
        } else {
          throw data.errorExplanation ? data.errorExplanation : data.errorText;
        }
      })
      .catch((err) => {
        dispatch(
          updateAlert({
            severity: "error",
            text: err,
            open: true,
          })
        );
        return { result: "1", nextStatus: true, msg: err };
      });
  };
};

export const generateOTP = (body) => {
  return async (dispatch) => {
    return await callService("generateOTP", body, dispatch, body.externalId)
      .then((response) => {
        const data = response.data;
        if (data.result === "1") {
          dispatch(updateGlobalState({ otpInfo: data }));
          return true;
        } else {
          throw data.errorExplanation ? data.errorExplanation : data.errorText;
        }
      })
      .catch((err) => {
        dispatch(
          updateAlert({
            severity: "error",
            text: err,
            open: true,
          })
        );
        return false;
      });
  };
};

export const generateOTPApplicant = (body) => {
  return async (dispatch) => {
    return await callService(
      "generateOTPApplicant",
      body,
      dispatch,
      body.externalId
    )
      .then((response) => {
        const data = response.data;
        if (data.result === "1") {
          dispatch(updateGlobalState({ otpInfo: data }));
          return true;
        } else {
          throw data.errorExplanation ? data.errorExplanation : data.errorText;
        }
      })
      .catch((err) => {
        dispatch(
          updateAlert({
            severity: "error",
            text: err,
            open: true,
          })
        );
        return false;
      });
  };
};

export const generateOtpEasycep = (body) => {
  return async (dispatch) => {
    return await callService(
      "generateOtpEasycep",
      body,
      dispatch,
      body.externalId
    )
      .then((response) => {
        const data = response.data;
        if (data.result === "1") {
          dispatch(updateGlobalState({ otpInfo: data }));
          return true;
        } else {
          throw data.errorExplanation ? data.errorExplanation : data.errorText;
        }
      })
      .catch((err) => {
        dispatch(
          updateAlert({
            severity: "error",
            text: err,
            open: true,
          })
        );
        return false;
      });
  };
};

export const validateOTP = (body) => {
  return async (dispatch) => {
    return await callService("validateOTP", body, dispatch, body.externalId)
      .then((response) => {
        const data = response.data;
        if (data.result === "1") {
          if (body.otpType === "SMS") {
            dispatch(updateCustomerInfo({ phoneValidationCheck: true }));
          } else if (body.otpType === "MAIL") {
            dispatch(updateCustomerInfo({ mailValidationCheck: true }));
          }

          //dispatch(updateGlobalState({otpInfo:data}));
          return true;
        } else {
          throw data.errorExplanation ? data.errorExplanation : data.errorText;
        }
      })
      .catch((err) => {
        dispatch(
          updateAlert({
            severity: "error",
            text: err,
            open: true,
          })
        );
        return false;
      });
  };
};
